import { dateDiff } from '@mirai/locale';

import { parseRate } from './helpers';
import { TYPE } from '../../../../Core.constants';
import { getFirstOccupationOption } from '../helpers';

export const ratesAddToCart = ({
  instances = [],
  response: { board: { id, name, rateId, roomId, roomName } = {}, cart = [], items = [], tracking = {} } = {},
  store: {
    currency,
    finder: { calendar = [], place: { id: [hotelId] = [] } = {}, promocode = '' } = {},
    id: instanceId,
    type,
  } = {},
} = {}) => {
  const { hotelInfo, rates = [] } = tracking;
  const room = rates.find(({ id } = {}) => id === roomId);
  const occupation = getFirstOccupationOption({ rates, roomId });
  const rate = occupation?.rates?.[rateId];

  const { rates: itemRates = [] } = items.find((item = {}) => item.id === roomId) || {};
  const { boardGroupName, totalBasePrice } = rate?.boardOptions?.[id] || {};
  const { days } = dateDiff(...calendar);

  const value = {
    coupon: promocode,
    currency,
    items: [
      parseRate({
        hotelId: type === TYPE.HOTEL ? instanceId : hotelId,
        hotelInfo,
        id,
        promocode,
        rate: {
          boardName: boardGroupName || name,
          rateName: rate?.name || itemRates.find(({ id } = {}) => id === rateId)?.name,
          roomTypeName: room?.name || roomName,
          totalPriceWithoutTaxes: totalBasePrice / days,
        },
      }),
    ],
    send_to: instances.map(({ idAnalytics }) => idAnalytics),
    value: cart.reduce((value, { netPrice = 0 } = {}) => value + netPrice, 0),
  };

  window.gtag('event', 'add_to_cart', value);

  return value;
};
